<div style="display: flex; flex-direction: column; justify-content: center; align-items: center">
<div class="spinner">
  <ion-spinner [color]="color" name="crescent"/>
</div>
  <ng-content/>
</div>
